<li
  class="recording-source-item"
  draggable="true"
  [ngClass]="{ dragged: dragged, 'list-mode': viewMode == 'list' }"
>
  <section>
    <icn-image [url]="item.image" *ngIf="item.image"></icn-image>
  </section>
  <div class="hover-layer">
    <section>
      <button
        data-title="SCHEDULER"
        inlineSVG="/assets/icons/thum-scheduler.svg"
        *ngIf="isChannel"
        (click)="gotoScheduler()"
      ></button>
      <button data-title="PREVIEW" (click)="previewSource()">
        <svg>
          <g>
            <path
              d="M10,1c5,0,9,4,9,9s-4,9-9,9s-9-4-9-9S5,1,10,1 M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0
                              L10,0z"
            />
            <polygon points="8,13.7 14,10 8,6.3" />
          </g>
        </svg>
      </button>
    </section>
  </div>
  <footer>
    <span>{{ item.name }}</span>
    <div
      class="media-icon recording over-hover-layer"
      [ngClass]="{ active: item.recording }"
      inlineSVG="/assets/icons/recording-start-new.svg"
      (click)="startRecordingSource()"
    ></div>
  </footer>
</li>
